import { createTheme } from '@mui/material';

let theme = createTheme({
	components: {
		MuiSnackbar: {
			styleOverrides: {
				root: {
					width: '1200px',
				},
			},
		},
	},
	typography: {
		fontFamily: ['Lato', 'Lucida Grande', 'Tahoma', 'Sans-Serif'].join(','),
		button: {
			fontWeight: 500,
		},
		body1: {
			fontWeight: 500,
		},
		body2: {
			fontWeight: 400,
		},
		// Non standard headings - to be brought in line for the design system
		'dashboard-card-heading': {
			fontSize: 24,
			fontWeight: 400,
			lineHeight: '32px',
			color: '#6F3D7E',
		},
	},
	palette: {
		primary: {
			light: `#A86DC3`,
			main: '#9952AD',
			dark: '#6F3D7E',
		},
		secondary: {
			light: '#6E678B',
			main: '#1F1C2B',
			dark: '#161320',
			contrastText: '#fff',
		},
		contrastThreshold: 3,
		tonalOffset: 0.2,
		background: {
			default: '#f7f7f7',
		},
		navigationButtonColor: {
			main: '#fff',
		},
		regNumberColor: {
			main: '#6F3D7E',
		},
		annualMileageFont: {
			main: '#000',
		},
		icon: {
			main: '#6F3D7E',
		},
	},
});

theme = createTheme(theme, {
	components: {
		MuiTypography: {
			defaultProps: {
				variantMapping: {
					'dashboard-card-heading': 'h2',
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: 0,
				},
			},
		},
		MuiAppBar: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.primary.main,
				},
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				root: {
					color: theme.palette.common.black,
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					borderColor: theme.palette.common.black,
				},
				notchedOutline: {
					borderColor: theme.palette.common.black,
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: ({ ownerState }: { ownerState: { color: string; variant?: string } }) => ({
					...(ownerState.variant !== 'text' && {
						...(ownerState.color === 'secondary' && {
							borderColor: theme.palette.common.black,
							':hover': {
								backgroundColor: '#6F3D7E',
							},
						}),
						...(ownerState.color === 'primary' && {
							borderColor: theme.palette.common.black,
							':hover': {
								backgroundColor: '#6F3D7E',
							},
						}),
					}),
				}),
			},
			variants: [
				{
					props: { variant: 'link' },
					style: {
						...theme.typography.body1,
						color: theme.palette.primary.main,
						textDecoration: 'underline',
						padding: 0,
						background: 'transparent',
						'&:hover': {
							color: theme.palette.primary.light,
							background: 'transparent',
							textDecoration: 'underline',
						},
						'&:visited': {
							background: 'transparent',
							color: theme.palette.primary.main,
							'&:hover': {
								color: theme.palette.primary.light,
							},
						},
					},
				},
			],
		},
		MuiToggleButton: {
			styleOverrides: {
				root: {
					color: theme.palette.common.black,
					borderColor: theme.palette.common.black,
					'&.Mui-selected': {
						backgroundColor: theme.palette.primary.main,
						color: theme.palette.common.white,
						'&:hover': {
							backgroundColor: theme.palette.primary.main,
						},
					},
				},
			},
		},
		MuiCssBaseline: {
			styleOverrides: `
        body, html, #root {
          height: 100%;
        }
        html {
          overflow-y: scroll;
        }
        /* ===== Scrollbar CSS ===== */
        /* Firefox */
        * {
          scrollbar-width: thin;
          scrollbar-color: ${theme.palette.grey[500]} ${theme.palette.background.default};
        }

        /* Chrome, Edge, and Safari */
        *::-webkit-scrollbar {
          width: 12px;
        }

        *::-webkit-scrollbar-track {
          background: ${theme.palette.background.default};
        }

        *::-webkit-scrollbar-thumb {
          background-color: ${theme.palette.grey[500]};
          border-radius: 10px;
          border: 3px solid ${theme.palette.background.default};
        }`,
		},
	},
});

const themeExport = theme;
export default themeExport;
